import * as React from 'react'
import { Tooltip } from '@lacedltd/laced-components'
import * as S from './Badge.styles'

const Badge: React.FC<BadgeProps> = ({
  text,
  children = undefined,
  tooltip = undefined,
  type = 'default',
  hover = false
}) => {
  if (!text) return null
  const badge = (
    <S.Badge variant={type} hover={hover} data-variant={type}>
      {text || children}
    </S.Badge>
  )

  return tooltip?.length ? <Tooltip value={tooltip}>{badge}</Tooltip> : badge
}

export default Badge

export type BadgeType = 'red' | 'orange' | 'green' | 'blue' | 'default'

export interface BadgeProps {
  text?: string
  children?: React.ReactNode
  tooltip?: string | null
  type?: BadgeType
  hover?: boolean
}
